/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TotoSettingsSmall = {
    properties: {
        userId: {
            type: 'number',
            isRequired: true,
        },
        adoptPredictions: {
            type: 'boolean',
            isRequired: true,
        },
        overwritePredictions: {
            type: 'boolean',
            isRequired: true,
        },
    },
} as const;
